<template>
  <el-card :class="cardClass" @click.native="handleCardClick">
    <div class="equip_list_hover" @click.stop="handleDetails">
      <img
        class="equipImg"
        :src="imageUrl"
        :alt="imageAlt"
        @error="setImageFallback"
      />
      <img class="purchase-icon" v-if="equipment.isSupportRetest == 1" src="https://pstatic.navi-sci.cn/4e23e98c-9e10-4a1b-943b-aa21e89af230" alt="">
      <div class="product_content_box">
        <div class="euqipName">{{ equipmentName }}</div>
        <div class="equipCode">{{ equipmentModel }}</div>
      </div>
    </div>
    <el-button type="primary" class="clickLook" size="small" @click.stop="handleAction">
      {{ buttonText }}
    </el-button>
    <slot name="metrics">
      <div class="otherNums">
        {{ purchase ? '已购买' : '已测试' }}
        <span class="numsColor">{{ equipment.testsNumber }}</span>次
      </div>
      <div class="otherNums">
        服务周期：平均
        <span class="numsColor">{{ equipment.serviceDays }}</span>个工作日
      </div>
    </slot>
  </el-card>
</template>

<script>
import defaultImage from "@/assets/img/morentupian.png";

export default {
  name: "EquipmentCard",
  props: {
    // 卡片展示的设备信息
    equipment: {
      type: Object,
      required: true,
    },
    // 试剂耗材使用购买文案，其他设备使用预约文案
    purchase: {
      type: Boolean,
      default: false,
    },
    // 文件服务地址由原页面传入，保持现有图片路径规则
    imagePrefix: {
      type: String,
      default: "",
    },
    // 首页卡片不使用列表页的入场动画
    animated: {
      type: Boolean,
      default: true,
    },
    // 仪器采购等特殊业务可以覆盖操作按钮文案
    actionLabel: {
      type: String,
      default: "",
    },
    // 仪器采购支持点击整张卡片进入详情
    fullCardClickable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultImage,
    };
  },
  computed: {
    cardClass() {
      return {
        equip_list: true,
        wow: this.animated,
        animate__fadeInUp: this.animated,
      };
    },
    equipmentName() {
      return this.equipment.equipmentName || this.equipment.name || "";
    },
    equipmentModel() {
      return this.equipment.equipmentModel || this.equipment.model || "";
    },
    imageUrl() {
      const fileList = this.equipment.fileList || [];
      if(fileList.length > 0) return this.imagePrefix + fileList[0].url;
      return this.equipment.picKey || this.defaultImage;
    },
    imageAlt() {
      return this.equipmentName
        ? `${this.equipmentName}-纳微创新设备`
        : "纳微创新设备";
    },
    buttonText() {
      return this.actionLabel || (this.purchase ? "立即购买" : "立即预约");
    },
  },
  methods: {
    // 点击设备主体时通知父页面进入详情
    handleDetails() {
      this.$emit("details", this.equipment);
    },
    // 特殊卡片允许空白区域也进入详情
    handleCardClick() {
      if(this.fullCardClickable) this.handleDetails();
    },
    // 操作行为由各页面处理，保留登录校验和业务跳转
    handleAction() {
      this.$emit("action", this.equipment);
    },
    setImageFallback(event) {
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style lang="scss" scoped>
.equip_list_hover {
  position: relative;
}
.purchase-icon {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 100px;
  height: 100px;
}
</style>